module.exports = __webpack_public_path__ + "img/solution-4.6b581b07.jpg";